import { z } from '../index.ts'

import { GetTimeSchema } from './time.ts'

const formatMinutes = (minutes: number) => {
  const hours = Math.floor(minutes / 60)
  const computedMinutes = minutes % 60
  return [hours && `~ ${hours} hr`, computedMinutes && `${computedMinutes} min`]
    .filter(Boolean)
    .join(' ')
}

export const GetDropSchema = z.object(
  {
    cargo_operations: z.string().nullish(),
    date: z.coerce.date({ message: 'Please select a date' }).nullish(),
    departure_time: z.coerce.date().nullish(),
    distance_to_next: z.coerce
      .number()
      .transform(data => `${parseFloat(data.toFixed(2))} km`)
      .nullish(),
    estimated_date: z.coerce.date().nullish(),
    estimated_time: GetTimeSchema.extend({ type: z.enum(['at', 'between']) }).nullish(),
    estimated_time_to_next: z.coerce
      .number()
      .transform(seconds => formatMinutes(Math.round(seconds / 60)))
      .nullish(),
    id: z.number(),
    loading_time: z.coerce.date().nullish(),
    name: z.string().nullish(),
    order: z.number(),
    reference_no: z.string().nullish(),
    reported_time: z.coerce.date().nullish(),
    time: GetTimeSchema,
    type: z.enum(['collection', 'delivery'], { message: 'Please select collection or delivery' }),
    unloading_time: z.coerce.date().nullish(),
  },
  { message: 'Please add pickup and delivery details' },
)

export const GetDropNoteSchema = z.object({
  comment: z.string().nullish(),
  drop_id: z.coerce.number(),
  id: z.coerce.number(),
  user_id: z.coerce.number(),
})

export const GetDropStatusSchema = z.object({
  alias: z.string(),
  title: z.string(),
})
